import React from 'react'
import PropTypes from 'prop-types'
import TenantsTable from './tenants-table'
import CreateTenantModal from './create-modal'
import * as request from 'services/request'

const Tenants = ({
  tenants,
  onCreateTenantClick,
  showCreateTenant,
  tenantCreateComplete,
  onUpdated,
  onSearch
}) => (
  <div>
    <div className='row'>
      <div className='col-md-3 form-group'>
        <div className='input-group' style={{ zIndex: 0 }}>
          <input
            type='text'
            className='form-control'
            placeholder='Search'
            onChange={onSearch}
          />
          <span className='input-group-btn'>
            <button className='btn red'>
              <i className='fa fa-search' />
            </button>
          </span>
        </div>
      </div>
      <div className='col-md-9 form-group' style={{ textAlign: 'right' }}>
        <button className='btn green' onClick={onCreateTenantClick}>
          <i className='fa fa-plus' /> Create New Tenant
        </button>
      </div>
    </div>
    <TenantsTable tenants={tenants} onUpdated={onUpdated} />
    <CreateTenantModal show={showCreateTenant} onClose={tenantCreateComplete} />
  </div>
)

Tenants.displayName = 'Tenants'

Tenants.propTypes = {
  tenants: PropTypes.array.isRequired,
  onCreateTenantClick: PropTypes.func.isRequired,
  onUpdated: PropTypes.func,
  onSearch: PropTypes.func,
  showCreateTenant: PropTypes.bool,
  tenantCreateComplete: PropTypes.func
}

class TenantsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tenants: [],
      creating: false,
      search: ''
    }

    this.getTenants = this.getTenants.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.showCreateModal = this.showCreateModal.bind(this)
    this.handleTenantCreateComplete = this.handleTenantCreateComplete.bind(this)
  }

  componentDidMount () {
    // istanbul ignore next
    this.getTenants()
  }

  async getTenants () {
    const response = await request.authorized(`/tenants`)
    const tenants = await response.json()

    this.setState({ tenants })
  }

  filteredTenants () {
    const { tenants, search } = this.state
    const matchSearchedName = tenant =>
      tenant.name.toLowerCase().includes(search.toLowerCase())
    const filteredTenants = search ? tenants.filter(matchSearchedName) : tenants

    return filteredTenants
  }

  handleSearch (e) {
    this.setState({ search: e.target.value })
  }

  showCreateModal () {
    this.setState({ creating: true })
  }

  handleTenantCreateComplete () {
    this.setState({ creating: false })
    this.getTenants()
  }

  render () {
    const { creating } = this.state

    return (
      <Tenants
        tenants={this.filteredTenants()}
        onUpdated={this.getTenants}
        onSearch={this.handleSearch}
        onCreateTenantClick={this.showCreateModal}
        showCreateTenant={creating}
        tenantCreateComplete={this.handleTenantCreateComplete}
      />
    )
  }
}

export { TenantsContainer as default, Tenants as TenantsComponent }



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/index.js